import script from "./ShopMixin.vue?vue&type=script&lang=js"
export * from "./ShopMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__